import { Suspense } from 'react'
import * as React from 'react'
import { observer } from 'mobx-react'
import CallParticipantViewModel from 'messaging/calling/CallParticipantViewModel'
import type { TwilioParticipantMedia } from 'messaging/calling/twilio/TwilioCallSource'

const TwilioMediaRenderers = {
  Video: React.lazy(
    () =>
      import(
        /* webpackChunkName: 'twilio' */ '../../twilio/TwilioVideoRenderer'
      )
  ),
  Audio: React.lazy(
    () => import(/* webpackChunkName: 'twilio' */ '../../twilio/TwilioAudio')
  ),
}

interface AudioRendererProps {
  vm: CallParticipantViewModel
}

/**
 " Audio Renderer
 */
export const AudioRenderer = observer(function AudioRenderer({
  vm,
}: AudioRendererProps) {
  if (!vm.media) {
    return null
  }

  // Currently Twilio is all we have support
  return (
    <Suspense fallback={<></>}>
      <TwilioMediaRenderers.Audio
        twilioMedia={vm.media as TwilioParticipantMedia}
      />
    </Suspense>
  )
})

interface VideoRendererProps {
  vm: CallParticipantViewModel
}

/**
 " Video Renderer
 */
export const VideoRenderer = observer(function VideoRenderer({
  vm,
}: VideoRendererProps) {
  if (!vm.media) {
    return null
  }

  // Currently Twilio is all we have support
  return (
    <Suspense fallback={<></>}>
      <TwilioMediaRenderers.Video
        twilioMedia={vm.media as TwilioParticipantMedia}
      />
    </Suspense>
  )
})
